/**
 * AgencySuccess — 발송대행 신청 접수 완료 카드
 */

import { cn } from '@/lib/utils';

interface AgencySuccessProps {
  requestId: string;
}

export function AgencySuccess({ requestId }: AgencySuccessProps) {
  return (
    <div
      className={cn(
        'ml-p-4 ml-rounded-cb-md',
        'ml-bg-gradient-to-br ml-from-brand-50 ml-to-white',
        'ml-border ml-border-brand-200'
      )}
    >
      <div className="ml-text-2xl ml-mb-2">✅</div>
      <div className="ml-text-cb-lg ml-font-semibold ml-text-brand-600 ml-mb-2">
        발송대행 신청이 접수되었습니다
      </div>
      <div className="ml-text-cb-base ml-text-ink-secondary ml-mb-3 ml-whitespace-pre-line">
        영업팀이 1영업일 내 입력하신 이메일과 연락처로 안내드리겠습니다.
      </div>
      <div
        className={cn(
          'ml-mt-3 ml-pt-3 ml-border-t ml-border-brand-200',
          'ml-flex ml-items-center ml-gap-2'
        )}
      >
        <span className="ml-text-cb-xs ml-text-mute">접수번호</span>
        <span className="ml-text-cb-sm ml-font-mono ml-font-semibold ml-text-brand-600">
          {requestId}
        </span>
      </div>
    </div>
  );
}
